export default __webpack_public_path__ + "static/media/cute.9f1c6f75.mp3";